// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 246 ? "cafc52b5" : chunkId) + "." + {"246":"3043ae90e485d8dd","715":"45d50907fd21a446"}[chunkId] + ".js";
};